import React from 'react';
import {Switch, Route} from 'react-router-dom';
import SampleChapterDiscover from './sampleChapterDiscover';
import SampleChapterReader from './sampleChapterReader';
import SampleChaptersHome from './sampleChaptersHome';
import SampleChapterEditor from './sampleChapterEditor';

const SampleChapters = () => (
  <Switch>
    <Route exact path="/sample-chapters" component={SampleChaptersHome} />
    <Route exact path="/sample-chapters/discover" component={SampleChapterDiscover} />
    <Route exact path="/sample-chapters/new" component={SampleChapterEditor} />
    <Route exact path="/sample-chapters/edit/:id" component={SampleChapterEditor} />
    <Route exact path="/sample-chapters/read/:id" component={SampleChapterReader} />
  </Switch>
);

export default SampleChapters;
